/** @jsxImportSource @emotion/react */
import { Styles } from './page-layout.styles';

export interface PageLayoutProps {
  children: {
    header: React.ReactNode;
    body: React.ReactNode;
  };
  className?: string;
}

export type PageLayoutType = React.FC<PageLayoutProps>;

export const PageLayout: PageLayoutType = ({ children, className }) => {
  return (
    <section className={className} css={Styles.container}>
      {children.header}
      {children.body}
    </section>
  );
};
